<template>
    <v-container fluid class="py-0" :class="{'isCheckout': isCheckout}" style="background-color: #117a9b;">
        <MainHeader :isCheckout="isCheckout" />
    </v-container>
</template>

<script>
    import MainHeader from "../Header/MainHeader";

    export default {
        name: 'NavBar',
        props: ['isCheckout'],
        components: {
            MainHeader
        }
    }
</script>
